import {useCallback} from "react";

/**
 * Creates a callback to commit uncommitted input in a TagsInput component
 *
 * @param tags - The tags object from useTagsInput
 * @param values - Current array of values
 * @param parseValue - Optional parser to validate/transform input before committing
 * @returns Callback to commit uncommitted input
 */
export function useCommitUncommitted<T>(
  tags: {inputValue: string; addValue: (value: string) => void; clearInputValue: () => void},
  values: T[],
  parseValue?: (input: string) => T | null,
) {
  return useCallback(() => {
    const trimmedInput = tags.inputValue.trim();
    if (!trimmedInput) return;

    const parsedValue = parseValue ? parseValue(trimmedInput) : (trimmedInput as T);

    if (parsedValue !== null && !values.includes(parsedValue)) {
      tags.addValue(trimmedInput);
      tags.clearInputValue();
    }
  }, [tags, values, parseValue]);
}
